import { ScalingSquaresSpinner } from "epic-spinners";
import StatusBar from "./components/StatusBar";
import ActionModal from "./components/ActionModal";
import { applyUpdate } from "./registerServiceWorker";
export default {
  name: "App",
  components: {
    StatusBar,
    ScalingSquaresSpinner,
    ActionModal
  },
  data: () => ({
    note: ""
  }),
  computed: {
    isBlockingNote() {
      // コメント内の文字列には反応しないよう、タグの属性として付いているかを見る
      return /<\w[^>]*\sdata-blocking[\s=>]/.test(this.note);
    }
  },
  mounted() {
    this.fetchNote();
    document.addEventListener("visibilitychange", this.handleVisibilityChange);
  },
  beforeDestroy() {
    document.removeEventListener("visibilitychange", this.handleVisibilityChange);
  },
  methods: {
    fetchNote() {
      fetch("/note.html", {
        cache: "no-cache"
      }).then(res => {
        res.text().then(html => {
          this.note = html;
        });
      });
    },
    handleVisibilityChange() {
      // モーダル表示中のみ、アプリに戻ったときに再取得して停止解除を反映する
      if (document.visibilityState === "visible" && this.isBlockingNote) {
        this.fetchNote();
      }
    },
    dismissUpdate() {
      this.$store.dispatch("setNewVersionAvailable", false);
    },
    handleApplyUpdate() {
      this.$store.dispatch("setNewVersionAvailable", false);
      applyUpdate();
    }
  }
};